export interface Handler<Request, Result = string> {
  setNext(next: Handler<Request, Result>): Handler<Request, Result>;
  handle(request: Request): Result | null;
}

export abstract class AbstractHandler<Type> implements Handler<Type> {
  private nextHandler?: Handler<Type>;

  public setNext(handler: Handler<Type>): Handler<Type> {
    this.nextHandler = handler;
    return handler;
  }

  public handle(request: Type): string | null {
    if (this.nextHandler) {
      return this.nextHandler.handle(request);
    }

    return null;
  }
}
